import React, { useState, useEffect, useCallback } from 'react';
import { ANIMATION_TIME_MILLISECONDS, REMOVE_TOAST_TIME_MILLISECONDS } from './constants.js';
import { ToastsContainer } from './styles.js';
import { ToastItem } from './ToastItem.js';

function Toast({ toasts }) {
    const [list, setList] = useState(toasts);
    useEffect(() => {
        setList([...toasts]);
    }, [toasts]);
    useEffect(() => {
        const interval = setInterval(() => {
            if (toasts.length && list.length) {
                const listsCopy = list.slice(1);
                setList([Object.assign(Object.assign({}, toasts[0]), { hide: true }), ...listsCopy]);
                setTimeout(() => onClose(toasts[0].id), ANIMATION_TIME_MILLISECONDS);
            }
        }, REMOVE_TOAST_TIME_MILLISECONDS);
        return () => clearInterval(interval);
    }, [toasts, list]);
    const onClose = useCallback((id) => {
        const listItemIndex = list.findIndex((item) => item.id === id);
        const toastItemIndex = toasts.findIndex((item) => item.id === id);
        list.splice(listItemIndex, 1);
        toasts.splice(toastItemIndex, 1);
        setList([...list]);
    }, [list, toasts]);
    return (React.createElement(ToastsContainer, null, list.map((toast) => (React.createElement(ToastItem, { key: toast.id, id: toast.id, message: toast.message, icon: toast.icon, hideInfoIcon: toast.hideInfoIcon, link: toast.link, variation: toast.variation, onClose: onClose, hide: toast.hide || false })))));
}

export { Toast };
